import AnnouncementRepo from "@/repositories/AnnouncementRepo";
import ProfessorRepo from "@/repositories/ProfessorRepo";
import CourseRepo from "@/repositories/CourseRepo";
import PackageRepo from "@/repositories/PackageRepo";
import ContactUsRepo from "@/repositories/ContactUsRepo";
import ProductSearchRepo from "@/repositories/ProductSearchRepo";
import MegaMenuRepo from "@/repositories/MegaMenuRepo";
import CategoryBannerRepo from '@/repositories/CategoryBannerRepo'
import PromotionBannersRepo from '@/repositories/PromotionBannersRepo'
import CourseVideosRepo from '@/repositories/CourseVideosRepo'
import OstadinoRepo from '@/repositories/OstadinoRepo'
import CampaignRepo from '@/repositories/CampaignRepo'

const repositories = {
    'Announcement'              : AnnouncementRepo,
    'Professors'                : ProfessorRepo,
    'Course'                    : CourseRepo,
    'CourseVideos'              : CourseVideosRepo,
    'Package'                   : PackageRepo,
    'ContactUs'                 : ContactUsRepo,
    'ProductSearch'             : ProductSearchRepo,
    'MegaMenu'                  : MegaMenuRepo,
    'CategoryBanner'            : CategoryBannerRepo,
    'PromotionBanners'          : PromotionBannersRepo,
    'Ostadino'                  : OstadinoRepo,
    'Campaign'                  : CampaignRepo,
};


export default {
    get: name => repositories[name]
};
